import { gql } from 'graphql-request';

export default gql`
  query CallDetailRecordsReport($fnName: String, $fnArgs: JSON) {
    callDetailRecordsReport(fnName: $fnName, fnArgs: $fnArgs) {
      result
    }
  }
`;
